export default {
  // en locale
  "login.otpLimit": "Otp sending limit exceed.Please try after some time",
  "login.headingDescription": "Seamless experience for conducting audits",
  "login.invalidCredentialsError":
    "You have entered an invalid email or password. Please try again",
  "login.userBlocked":
    "You have been blocked please connect with administrator",
  "login.maxLoginUserLimitReached":
    "Account is already active in another device",
  "login.enterOtp": "Enter OTP",
  "login.otpHasBeenShared":
    "A OTP has been shared to your registered Email address/Mobile number",
  "login.wrongOtpError": "Wrong otp, Please try again",
  "login.resendOtpSuccess": "Otp sent successfully",
  "login.resendOtpErr":
    "You have had 4 wrong attempts, You can send next otp after 15(timer) minutes",
  "login.success": "You are successfully logged in",
  "login.forgotPassword": "Forgot password?",
  "login.forgotDescription":
    "Don't worry, we'll provide you with the reset instructions",
  "login.label.email": "Email",
  "login.label.password": "Password",
  "login.label.newPassword": "New Password",
  "login.label.confirmPassword": "Confirm New Password",
  "login.button.login": "Log in",
  "button.submit": "Submit",
  "button.save": "Save",
  "login.otpNotReceive": "Didn’t receive the OTP?",
  "login.resendOtp": "Click to resend",
  "login.label.otp": "OTP",
  "login.resendIn": "You can resend OTP in ",
  "login.otpAttempts":
    "You have requested an otp for 4 times, you can send again in",
  "login.welcomeBack": "Welcome back!",
  "login.welcomeToOurCommunity": "Welcome to our community",
  "login.logIntoYourAccount": "Log in to your account",
  "login.placeholder.email": "Enter your email",
  "login.placeholder.password": "Enter your password",
  "login.placeholder.newPassword": "Enter your new password",
  "login.placeholder.confirmPassword": "Confirm your new password",
  "login.fieldError.email.required": "Email is required",
  "login.fieldError.email.invalid": "Not a valid email, Please enter again",
  "login.fieldError.password.required": "Password is required",
  "login.fieldError.password.invalid": "Please enter valid password",
  "login.fieldError.password.max": "Maximum characters allowed is 20",
  "login.fieldError.password.min": "Minimum 8 characters are required",
  "login.backToLogin": "Back to log in",
  "login.button.resetPassword": "Reset Password",
  "login.resetInstruction":
    "Don't worry, we'll provide you with the reset instructions.",
  "login.createNewPassword": "Create New Password",
  "login.differentPassword":
    "Your new password must be different from previous used password.",
  "login.passwordRequirements":
    "Password must meet the following requirement(s):",
  "login.resetLinkExpired":
    "Your reset Link has expired. Please create a new one.",
  "login.resetMailSentMessage":
    "Thanks! If there's an account associated with this email, we'll send the password reset instructions immediately.",
  "login.button.confirm": "Confirm",
  "dashboard.popup.heading": "Quick Links",
  "dashboard.popup.listHeadingDashboard": "Dashboard",
  "dashboard.popup.listHeadingUserManagement": "User Management",
  "dashboard.popup.listHeadingManageProductCategories":
    "Manage Product Categories",
  "dashboard.popup.listHeadingManageAudits": "Manage Audits",
  "dashboard.popup.listHeadingManageAuditsQuestion":
    "Manage Audit Questionnaire",
  "dashboard.popup.listHeadingReports": "Reports",
  "dashboard.popup.listDescription": "Manage all the contents",
  "nav.viewMyAccount": "View My Account",
  "nav.logOut": "Log Out",
  "login.passwordChangedSuccess": "Your Password has been changed successfully",
  "login.passwordsDoNotMatch":
    "New password and Confirm password do not match, Please enter again",
  "login.passwordChanged": "Password Changed!",
  "error.somethingWentWrong": "Something went wrong",
  "error.auditAlreadyInProgress":
    "Audit is already in progress for DNSD {name}",
  "error.noParticipantFound": "No one has joined the call yet",
  "error.dataNotFound": "No data available to download report",
  "error.productCategoryInValidInput": "Please enter valid input",
  "productCategory.productCategoryAdded": "Product Category added successfully",
  "productCategory.listingHeading": "Manage Product Category",
  "productCategory.columnOneHeading": "Product Category",
  "productCategory.columnTwoHeading": "Sub - Product Category",
  "productCategory.addNewProductCategory": "Add New Product category",
  "productCategory.editProductCategory": "Edit Product category",
  "productCategory.viewProductCategory": "View Product Category Details",
  "pagination.selectLabelSuffix": "per page",
  "productCategory.searchPlaceholder":
    "Search by product category & sub product category",
  "pagination.prevText": "Prev",
  "pagination.nextText": "Next",
  "nav.switchProfile": "Switch Profile",
  "login.loggedOut": "Logged out successfully",
  "productCategory.productCategoryName": "Product Category Name",
  "productCategory.productCategoryName.placeholder":
    "Enter Product Category Name",
  "button.text.cancel": "Cancel",
  "button.text.save": "Save",
  "button.text.addProductCategory": "Add Product Category",
  "error.productCategory.unique":
    "Sub-Product Category {subCategory} already exists in the system",
  "productCategory.subProductCategory": "Sub-Product Category",
  "productCategory.addSubProductCategory":
    "Add sub-product category & assign it to country.",
  "productCategory.viewSubProductCategory":
    "View sub-product category & its assigned country.",
  "productCategory.enterSubProductCategoryName":
    "Enter Sub-Product Category Name",
  "productCategory.selectCountry": "Select Country",
  "button.text.addMore": "Add More",
  "button.save": "Save",
  "account.changePassword": "Change Password",
  "account.notificationSettings": "Notification Settings",
  "account.receiveOverEmail": "Receive over email",
  "account.receiveOverSms": "Receive over SMS",
  "account.webPortalNotifications": "Web portal notifications",
  "account.changePasswordDescription":
    "Changing the log in password frequently prevents unauthorized users from modifying the configurations.",
  "account.label.Password": "Old Password",
  "account.label.Password.placeHolder": "Enter your old password",
  "account.heading.myAccountDetails": "My Account Details",
  "account.changePassword.successMsg":
    "Password changed successfully. Please login again",
  "account.changeUserPassword.successMsg": "Password changed successfully",
  "account.notificationSetting.successMsg":
    "Notification settings changed successfully",
  savedSuccessFully: "Saved successfully",
  "productCategory.requiredSubProductCategory":
    "At-least one sub-product category is required",
  "productCategory.addMore": "Add More",
  "productCategory.markActiveInactive": "Mark Active/Inactive",
  "productCategory.markActiveInactiveDesc":
    "Select countries within the sub-product categories of {name} and designate it as active/inactive.",
  "productCategory.noCountryAssigned":
    "No country assigned to this subcategory",
  "manageQuestionnaire.addedSuccessfully": "Questionnaire added successfully",
  "manageQuestionnaire.updatedSuccessfully":
    "Questionnaire updated successfully",
  "manageQuestionnaire.minOneSectionRequired":
    "At-least one section is required",
  "manageQuestionnaire.replaceBaseQuestionnaire":
    "Replace primary questionnaire",
  "account.oldPassword.noMatch": "Old password does not match",
  "manageQuestionnaire.addNewQuestionnaire": "Add New Questionnaire",
  "manageQuestionnaire.editQuestionnaire": "Edit Questionnaire",
  "manageQuestionnaire.editQuestionnaire.btn": "Save",
  "manageQuestionnaire.viewQuestionnaire": "View Questionnaire",
  "manageQuestionnaire.addQuestionnaire": "Add Questionnaire",
  // "manageQuestionnaire.evaluationStatusValues": "Pending / Done / Issues",
  // "manageQuestionnaire.attachmentOptionsHeading": "Attachment Options",
  // "manageQuestionnaire.attachmentValues": "Snapshots / Videos /Recordings",
  "manageQuestionnaire.chooseType": "Choose Audit Questionnaire Type",
  "manageQuestionnaire.questionnaireType": "Questionnaire Type",
  "manageQuestionnaire.markPrimary": "Mark As Primary Form",
  "manageQuestionnaire.namePlaceholder": "Enter Questionnaire Name",
  "manageQuestionnaire.namePlaceholderGeneral": "Enter Name",
  "manageQuestionnaire.questionPlaceholder": "Enter Question",
  "manageQuestionnaire.optionPlaceholder": "Enter Option",
  "manageQuestionnaire.mandatory": "Mandatory",
  "manageQuestionnaire.addOption": "Add Option",
  "manageQuestionnaire.questionnaireNameRequired":
    "Questionnaire name is required",
  "manageQuestionnaire.requiredFields":
    "All section names and question names are required",
  "manageQuestionnaire.questionShouldHaveMinTwoOptions":
    "All single select and multi select question should have minimum two options filled",
  "manageQuestionnaire.questionShouldHaveAllOptionsFilled":
    "All options in single select and multi select questions should be filled",
  "manageQuestionnaire.lowestLevelHasNoQuestion":
    "Any lowest of section/sub-section cannot be added without question",
  "manageQuestionnaire.allowAdditionTextbox": "Allow Additional Textbox",
  "manageQuestionnaire.deleteQuestion":
    "Are you sure you want to delete {name} question ?",
  "manageQuestionnaire.deleteSection":
    "Are you sure you want to delete  {name} section?",
  "manageQuestionnaire.deleteOption":
    "Are you sure you want to delete {name} option?",
  "manageQuestionnaire.modal.description":
    "{name} has been marked as the base questionnaire for operational audit. Would you like to replace it?",
  "manageQuestionnaire.addNewSection": "Add New Section",
  "manageQuestionnaire.questionTypePlaceholder": "Select Question Type",
  "questionnaire.addQuestionnaireWarningMobile":
    "This feature is not available on mobile phones, please access the same using a tablet/desktop",
  "manageQuestionnaire.addNewSubSection": "Add Sub Section",
  "manageQuestionnaire.addNewQuestion": "Add Question",
  "manageQuestionnaire.maxLimitError": "Maximum sub-levels limit reached.",
  "manageQuestionnaire.primary": "Primary",
  "manageQuestionnaire.operational": "Operational",
  "manageQuestionnaire.repair": "Repair",
  "userManagement.roleName.densoService": "DENSO Service Dealer",
  "userManagement.roleName.countryAdmin": "Country Admin",
  "userManagement.roleName.teamMember": "Team Member",
  "userManagement.roleName.tm": "TM",
  "userManagement.roleName.dnsd": "DNSD",
  "userManagement.addNewUser": "Add New User",
  "userManagement.editUser": "Edit User",
  "button.text.addUserManagement": "Add User",
  "userManagement.searchPlaceholder":
    "Search by name, email, global ID, employee ID or country",
  "button.generateReport": "Generate Report",
  "userManagement.listHeading": "User Management",
  "userManagement.tableHeader.name": "Name",
  "userManagement.tableHeader.email": "Email",
  "userManagement.tableHeader.mobileNo": "Mobile Number",
  "userManagement.tableHeader.county": "Country",
  "userManagement.tableHeader.roles": "Roles",
  "actionsOption.viewDetails": "View details",
  "actionsOption.editDetails": "Edit details",
  "actionsOption.blockUser": "{blockOrUnblock} user",
  "userManagement.button.block": "Block",
  "userManagement.button.unBlock": "Unblock",
  "userManagement.button.addRemark": "Add Remarks*",
  "userManagement.button.blockUnblockDesc":
    "Are you sure that you want to {blockOrUnblock} {name}?",
  "userManagement.blockUnblockMsg": "{name} {blockOrUnblock} successfully",
  "addUser.productCategoryRequired":
    "Please assign at-least one product category and sub-product category",
  "addUser.addUserName": "Name",
  "addUser.addUserName.placeholder": "Enter user name",
  "addUser.addUserEmail": "Email",
  "addUser.addUserEmail.placeholder": "Enter Email",
  "addUser.addUserMobile": "Mobile number",
  "addUser.addUserMobile.placeholder": "Enter mobile number",
  "addUser.addUserEmployeeId": "Employee ID",
  "addUser.addUserEmployeeId.placeholder": "Enter employee id",
  "addUser.selectUserRole.placeholder": "Select user role",
  "addUser.selectUserCountry.placeholder": "Select country",
  "addUser.text.basicDetails": "Basic Details",
  "addUser.text.userRoleDetails": "User Role Details",
  "addUser.text.operationAndRepairAudit":
    "Operations audit & repair audit performed by TM",
  "addUser.text.operationAudit": "Operations Audit",
  "addUser.text.repairAudit": "Repair Audit",
  "addUser.text.profileImage": "Profile Image",
  "uploadImage.text.dropFileHere": "Drag & Drop your file here",
  "uploadImage.text.maxSizeFile":
    "Max size allowed 5 mb. Format supported : JPEG and PNG",
  "uploadImage.text.or": "or",
  "addUser.text.categoryProductAndSubProduct": "Product & Sub Product Category",
  "addUser.label.country": "Country",
  "addUser.label.selectUserRole": "Select User Role",
  "uploadImage.text.browseFile": "Browse File",
  "additionEmail.text": "DNSD Additional Email",
  "address.dnsd.text.placeholder": "Enter DNSD address",
  "address.dnsd.text": "DNSD Address",
  "addUser.text.repairDoneAudit": "Repair audit done for DNSD or not",
  "address.dnsd.textArea": "Enter DNSD Address",
  "addUser.exist.additionalEmail":
    "One of the additional email address is already in use for this user, please enter again",
  "addUser.invalid.text.additionalEmail": "The email address is invalid",
  "addUser.fieldError.name.required": "Name is required",
  "addUser.fieldError.email.required": "Email is required",
  "addUser.fieldError.email.invalid": "Not a valid email",
  "addUser.fieldError.userRole.required": "User role is required",
  "addUser.fieldError.employeeId.required": "Employee id is required",
  "addUser.fieldError.address.required": "DNSD address is required",
  "addUser.fieldError.countryId.required": "Country is required",
  "addUser.fieldError.userRole.select.atleast1": "Select at least one role",
  "error.addUserEmailUnique":
    "This email id is already in use for another user, please enter again",
  "error.addUserEmployeeIdUnique":
    "This employee id is already in use for another user, please enter again",
  "error.addUserGlobalIdUnique":
    "This global id is already in use for another user, please enter again",
  "error.addUserOtherEmailUnique":
    "Some/One of the additional email address is already in use for another user, please enter again”",
  "addUser.addGlobalID": "Global ID",
  "addUser.addUserGlobalId.placeholder": "Enter global id",
  "addUser.fieldError.globalId.required": "Global Id is required",
  "addUser.fieldError.globalId.invalid":
    "Not a valid global id, Please enter again",
  "addUser.fieldError.employeeId.invalid":
    "Not a valid employee id, Please enter again",
  "addUser.fieldError.mobile.invalid":
    "Not a valid mobile number, Please enter again",
  "addUser.fieldError.mobile.max":"Maximum numbers allowed is 15",
  "addUser.fieldError.mobile.min":"Minimum 6 numbers are required",
  "addUser.fieldError.countryCode.invalid":
    "Country Code is required",
  "addUser.text.confirmPopup":
    "The country code selected in the mobile number and the country selected in the user role details do not match. Are you sure you want to proceed?",
  "userManagement.block": "Block",
  "userManagement.unBlock": "Unblock",
  "userManagement.viewUserDetails": "View User Details",
  "userManagement.addedUser": "User added successfully",
  "questionnaire.listHeading": "Manage Audit Questionnaire",
  "questionnaire.searchPlaceholder": "Search by questionnaire name",
  "questionnaire.addNewQuestionnaire": "Add New Questionnaire",
  "questionnaire.tableHeader.name": "Questionnaire Name",
  "questionnaire.tableHeader.type": "Questionnaire Type",
  "questionnaire.tableHeader.productCategory": "Product Category",
  "questionnaire.tableHeader.subProductCategory": "Sub-Product Category",
  "actionsOption.viewCountryWiseQuestionnaire":
    "View country wise questionnaire",
  "actionsOption.assignSubProductCategory": "Assign sub-product category",
  "button.text.editUserManagement": "Save",
  "userManagement.editedUser": "User updated successfully",
  "error.addUserRequiredProducts": "Please select products and sub products",
  "searchProducts.placeholder.searchProductCategory":
    "Search products category",
  "searchSubProducts.placeholder.searchSubProductCategory":
    "Search sub products category",
  "uploadImage.error.maxSizeAllowed":
    "Max size allowed is 5 mb. Please upload again",
  "uploadImage.error.formatSupportedPngAndJpeg":
    "Only JPEG and PNG can be uploaded.Please upload again",
  "uploadImage.error.sizeExceeded": "Image size exceeded!",
  "uploadImage.error.formatNotSupported": "Format not supported",
  "viewUser.label.email": "Email",
  "viewUser.label.mobileNo": "Mobile No",
  "viewUser.details.image": "Uploaded Image",
  "address.additionalEmailId.text": "Additional Email ID",
  "viewUserDetails.text.roleName": "Role Name",
  "viewUserDetails.repairAuditDone": "Repair audit done for DNSD or not",
  "planAudit.heading.planAudit": "Plan Audit",
  "addUser.exist.additionalEmailSame":
    "One of the additional email address is already in use for this user, please enter again",
  "viewUser.label.blockedRemark": "Block Remark",
  "viewQuestionnaire.text.primary": "Primary",
  "questionnaire.tableHeader.assignedProductCategory":
    "Assigned Product Category",
  "questionnaire.tableHeader.assignedSubProductCategory":
    "Assigned Sub-Product Category",
  "switchProfile.text": "Switch Profile",
  "switchProfile.successMsg":
    "You have successfully switched your profile to {role}",
  "planAudit.fieldError.plannedMonth.required": "Planned month is required",
  "planAudit.fieldError.auditType.required": "Audit type is required",
  "planAudit.fieldError.productSubProduct.required":
    "Product and sub product is required",
  "planAudit.fieldError.dnsd.required": "DNSD is required",
  "planAudit.fieldError.tm.required": "TM is required",
  "planAudit.fieldError.tentativeDate.required": "Tentative date is required",
  "planAudit.selectMonth.placeholder": "Select month",
  "planAudit.selectAuditType.placeholder": "Select audit type",
  "planAudit.selectTM.placeholder": "Select TM",
  "planAudit.selectSubProductCategory.placeholder":
    "Select Sub Product Category",
  "planAudit.selectMonth.label": "Current Financial Year’s  Planned Month",
  "planAudit.subCategory.label": " Select Sub Product Category",
  "planAudit.dnsd.placeholder": "Select DNSD",
  "planAudit.dnsd.label": "DNSD",
  "planAudit.tm.placeholder": "Select TM",
  "planAudit.table.tm": "TM",
  "planAudit.table.dnsd": "DNSD",
  "planAudit.table.tentativeDate": "Tentative Date",
  "planAudit.subCategory.placeholder": " Select Sub Product Category",
  "planAudit.selectAuditType.label": "Audit Type",
  "planAudit.noQuestionnaireAssigned": "No Questionnaire assigned",
  "planAudit.noQuestionnaireAssigned.desc":
    "No Questionnaire assigned to it,cannot plan an audit for this sub-category.",
  "planAudit.noQuestionnairePrimary":
    "No operational questionnaire is marked as primary",
  "planAudit.noQuestionnairePrimary.desc":
    "Main admin has not marked any Questionnaire as primary, please contact them for same.",
  "text.okay": "Okay",
  "planAudit.selectTentativeDate.label": "Select Tentative Date",
  "select.subProduct.toQuestionnaire":
    "Select a sub-product category to assign {name}",
  "assign.subProduct.toQuestionnaire": "Assign Sub-Product Category",
  "button.text.assign": "Assign",
  "manageQuestionnaire.replace.modal.description":
    "Are you sure you want to replace it?",
  "audit.submit.confirmation": "Are you sure you want to submit this Audit?",
  "audit.complete.confirmation":
    "Are you sure you want to mark this Audit completed.",
  "audit.complete.confirmation.desc":
    "You won' be able to edit once marked completed.",
  "manageAudit.fillAtLeastOneResponse":
    "Please fill atleast one response to submit the audit",
  "button.text.no": "No",
  "button.text.yes": "Yes",
  "button.text.update": "Update",
  "assigned.subProductToQuestionnaire.succesfully":
    "Assigned product sub category to questionnaire successfully",
  "assinged.subCategory.modal.text":
    "{subCategoryName} has already been assigned to {questionnaireName}. ",
  "error.pleaseSelect.product.Msg": "Please Select Product",
  "error.pleaseSelect.Subproduct.Msg": "Please Select Sub Product Category",
  "productCategory.productCategoryRequired":
    "Product category name is required",
  "productCategory.productCategoryUpdated":
    "Product category updated successfully",
  "manageAudit.fillAtLeastOneResponse":
    "Please fill at least one response to submit the audit",
  "manageAudit.fillAtLeastOneResponse.reAuditPending":
    "The response is still the same as before. Please update response to submit the audit.",
  "date.format": "DD MMMM YYYY",
  "planAudit.fieldError.select.atLeast1": "Select at least one DNSD",
  "auditListing.plannedMonth": "Planned Month",
  "auditListing.country": "Country",
  "auditListing.auditType": "Audit Type",
  "auditListing.DNSDName": "DNSD",
  "auditListing.globalId": "Global ID",
  "auditListing.tm": "TM",
  "auditListing.productCategory": "Product Category",
  "auditListing.productSubCategory": "Sub-Product Category",
  "auditListing.currentAuditMode": "Current Audit Mode",
  "auditListing.auditStatus": "Audit Status",
  "auditListing.startDate": "Start Date",
  "auditListing.endDate": "End Month",
  "auditPreview.reAuditDueDate": "Re-audit {index} due date",
  "auditPreview:firstAudit": "Audit {index}",
  "auditListing.currentAuditDueDate": "Current Re-audit due date",
  "auditListing.audit": "Audit",
  "auditListing.searchPlaceholder": "Search by product category & sub-category",
  "auditListing.displayDateFormat": "DD MMM, YY",
  "auditListing.displayMonthFormat": "MMM, YY",
  "auditListing.action.markOnHold": "Mark on hold",
  "auditListing.action.markOnHoldReasonPlaceholder": "Add Reason*",
  "auditListing.action.markOnHoldReasonLabel": "Reason for hold :",
  "auditListing.action.statusChangeModalTitle":
    "Are you sure that you want to change status of this audit?",
  "auditListing.action.startAudit": "Start audit",
  "auditListing.action.setAuditType": "Set audit mode",
  "auditListing.action.setReAuditDateNType": "Select Re-Audit Due Date",
  "auditListing.action.setAuditTypeModalLabel": "Select audit mode",
  "auditListing.action.continueAudit": "Continue audit",
  "auditListing.action.markPending": "Mark pending",
  "auditListing.action.sentReportToSD": "Sent Report to SD",
  "auditListing.action.downloadReport": "Download Report",
  "auditListing.action.sendAuditPdfToSD": "Send Audit pdf to SD",
  "auditListing.action.markAuditCompleted": "Mark Audit Completed",
  "auditListing.action.sendLinkToDNSD": "Send link to DNSD",
  "auditListing.action.copyLink": "Copy Link",
  "auditListing.msg.likCopied": "Link Copied",
  "auditListing.action.sendForReAudit": "Send for Re-audit",
  "auditListing.action.editAuditForm": "Edit Audit",
  "auditListing.action.viewPreviewMode": "View Preview mode",
  "auditListing.action.downloadExcelReport": "Download excel report",
  "auditListing.action.joinVideoCall": "Join video call",
  "auditListing.action.updateTM": "Update TM",
  "auditListing.modal.selectTM": "Select TM",
  "auditListing.modal.canNotStartAudit": "No audit mode assigned.",
  "auditListing.modal.canNotStartAuditDesc":
    "Please select audit mode to start audit.",
  "modal.countryWise.viewQuestionnaire": "View country wise questionnaire",
  "modal.description.chooseCountry":
    "Please choose a country to access the questionnaire for {subProductName}",
  "modal.description.chooseCountryForOperational":
    "Please choose a country to access the questionnaire",
  "modal.text.baseFormEdited": "Base form edited",
  "modal.text.questionnaireView": "View Questionnaire",
  "modal.noCategoryAssigned.title": "No sub-category assigned",
  "modal.noSubCategoryAssigned.description":
    "No subcategory has been assigned to {questionnaireName}",
  "button.text.close": "Close",
  "button.text.goBack": "Go Back",
  "button.text.questionnaireView": "View Questionnaire",
  "modal.noCountryAssignedToQuestionnaire.title":
    "The assigned sub-category to this questionnaire does not have a country assigned to it.",
  "modal.viewBaseForm.description":
    "Would you like to view the base form assigned to {questionnaireName} instead?",
  "modal.viewQuestionnaireCountryName.text": "Questionnaire for {countryName}",
  "modal.text.baseForm": "Base form",
  "notifications.heading.myNotifications": "Notifications",
  "notifications.text.seeAll": "See all notifications",
  "blockUser.modal.maxChar100": "Maximum 100 characters allowed",
  "manageAudit.autoSaveWarning":
    "Your response to any question will be auto-saved as soon as you fill it out",
  "manageAudit.previewAudit": "View Audit Details",
  "manageAudit.F2FHeading": "F2F - Audit",
  "manageAudit.SelfHeading": "Self - Audit",
  "manageAudit.RemoteHeading": "Remote - Audit",
  "manageAudit.addRemark": "Add Remark",
  "manageAudit.notFound": "Not found",
  "manageAudit.F2F.evaluationStatusHeading": "Evaluation Status",
  "manageAudit.F2F.evaluationStatusPlaceholder": "Select Evaluation Status",
  "manageAudit.F2F.addCounterMeasurePlaceholder": "Add Counter Measure",
  "manageAudit.F2F.enterResponsePlaceholder": "Enter Response",
  "manageAudit.self.enterResponsePlaceholder": "Enter Response",
  "manageAudit.F2F.mandatoryFieldsError":
    "Response and evaluation status for all mandatory questions is required",
  "manageAudit.Self.mandatoryFieldsErrorForTM":
    "Response for all mandatory questions is required",
  "manageAudit.F2F.auditSubmittedSuccess": "Audit submitted successfully",
  "auditListing.reAuditDueDate": "Re-audit due date",
  "manageAudit.F2F.savedSuccess": "Response saved successfully",
  "mangeAudit.F2F.auditDueHeading": "Re-audit due date",
  "manageAudit.remote.camLabel": "Camera is {text}",
  "manageAudit.remote.camIsStarting": "starting",
  "manageAudit.remote.camIsOff": "off",
  "error.evidenceInProgressViaTwilio": "Evidence uploading is in progress",
  "evidence.videos": "Videos",
  "evidence.snapshots": "Snapshots",
  "evidence.video": "Video",
  "evidence.snapshot": "Snapshot",
  "evidence.snap": "Snap",
  "evidence.takeSnapshot": "Take Snapshot",
  "evidence.recordVideo": "Record Video",
  "evidence.videoRecording": "Video Recording",
  "evidence.audioRecording": "Audio Recording",
  "evidence.startVideoRecording": "Start Video Recording",
  "evidence.stopRecording": "Stop Recording",
  "evidence.recordingAudio": "Recording Audio",
  "evidence.recordings": "Recordings",
  "evidence.greenFlag": "Green Flag",
  "evidence.redFlag": "Red Flag",
  "videoCall.endCall": "End call",
  "evidence.recordAudio": "Record Audio",
  "evidence.recordingAudioInProgressWarning":
    "Stop current recording to start recording new evidence",
  "evidence.cameraOff":
    "DNSD camera is off. Camera should be on for video recording.",
  "evidence.audioOff": "DNSD mic is off. Mic should be on for audio recording.",
  provideCamAccess:
    "Please provide access to your webcam on browser and refresh the same",
  provideMicrophoneAccess:
    "Please provide access to your microphone on browser and refresh the same",
  "dashboard.listHeading": "Dashboard",
  "dashboard.year": "Year",
  "dashboard.country": "COUNTRY",
  "dashboard.operationAudit.label": "Total Audits vs Complete Audits",
  "dashboard.totalAuditVsCompleteAudit.label":
    "Planned vs Complete Audits: Month Wise",
  "dashboard.gradingGraph.label": "GRADING GRAPH",
  "dashboard.radarGraph.label": "Radar Graph",
  "dashboard.switchNumberLabel": "Number",
  "dashboard.switchPercentageLabel": "Percentage",
  "dashboard.level2.label": "LEVEL 2",
  "dashboard.level3.label": "LEVEL 3",
  "dashboard.level4.label": "LEVEL 4",
  "dashboard.level5.label": "LEVEL 5",
  "gradingGraph.labelValue": "Number of DNSD",
  "levelGraph.payload.value1": "Total questions",
  "levelGraph.payload.value2": "Total SD with evaluation status OK",
  "reports.cannotGenerateData":
    "Can't generate report as there is no data found",
  "auditListing.msg.sendLinkToDnsd": "Link Sent To DNSD",
  "auditListing.msg.sendReportToDnsd": "Report sent to DNSD",
  "auditListing.msg.reportDownloaded": "Report Downloaded",
  "dnsd.selfAudit.submittedMsg":
    "Thanks, Your audit response has been submitted successfully.",
  "dnsd.selfAudit.linkExpired":
    "This link has expired. Please request for a new one from the respective TM of this Audit.",
  "auditListing.downloadPdf": "Download PDF",
  "auditCompleted.evaluationStatusNotFilled":
    "Please add the evaluation status to mark the audit completed",
  "auditCompleted.evaluationStatusNotFilledReAudit":
    "Please add the evaluation status to send the audit for Re-Audit",
  "graphs.containerError.label": "Chart container not found",
  "radar.link.label": "Radar-Graph.png",
  "grading.link.label": "Grading-Graph.png",
  "totalAuditVsCompleted.link.label":
    "Planned vs Complete Audits: Month Wise.png",
  "level2.link.label": "Level2-Graph.png",
  "level3.link.label": "Level3-Graph.png",
  "level4.link.label": "Level4-Graph.png",
  "level5.link.label": "Level5-Graph.png",
  "operationAudit.link.label": "OperationAudit-Graph.png",
  "downloadReport.label": "Download Report",
  "downloadGraph.label": "Download Graph",
  "levelGraphs.legend1.label": "OK Count",
  "levelGraphs.legend2.label": "Question Count",
  "completedAudit.label": "Completed Audit",
  "completedRepairAudit.label": "Completed Repair Audit",
  "completedOperationAudit.label": "Completed Operation Audit",
  "auditReport.label": "auditReport",
  "totalAudit.label": "Total Audit",
  "totalOperationalAudit.label": "Total Operational Audit",
  "totalRepairAudit.label": "Total Repair Audit",
  "totalCompletedAudit.label": "Total Completed Audit",
  "dnsd.popup.msg":
    "You are currently logged in as another user. Are you sure? You want to continue.",
  "dnsd.selfAudit.auditOnHold": "Audit on hold. Audit can't be done",
  "dnsd.selfAudit.onHold":
    "This Audit has been marked On Hold. Please contact the respective TM of this Audit.",
  "errorPage.routes.value": "Page not found",
  "errorPage.header.value": "Oops! An Error Occurred",
  "button.text.prevQuestion": "Prev Question",
  "button.text.nextQuestion": "Next Question",
  "cancelButton.label": "Cancel",
  "joinButton.label": "Join Now",
  "waiting.label": "Waiting...",
  "getStarted.label": "Get Started",
  "setupAudioAndVideo.label": "Setup your audio and video before joining",
  "e-audit.label": "E - Audit",
  "dnsd.selfAudit.auditMediumNotSelf":
    "The mode of the audit has been changed, please access the new link to view the audit form",
  "dnsd.selfAudit.questionnaireNotAssigned":
    "No Questionnaire Assigned. Please assign one to perform this audit",
  "selectCategories.label":
    "To view this Graph, Please Select Country, Year, Type and SubProduct Category",
  "selectCategories.CA.TM.label":
    "To view this Graph, Please select Year, Type and SubProduct Category",
  "selectCountryYearType.label": "Please Select Country, Year and Type",
  "dataNotAvailable.label":
    "No Questionnaire exists corresponding to selected filter",
  "level.doesNotExist":
    "No level {level} exists corresponding to selected filters.",
  "changeAuditType.label": "Please Change your type to Repair",
  "levelReport.label": "levelReport",
  "gradingReport.label": "gradeReport",
  "totalAuditsVsCompleteAuditsPng.label": "Total Audits vs Complete Audits.png",
  "remainingCount.label": "remainingCount",
  "okCount.label": "okCount",
  "name.label": "name",
  "value.label": "value",
  "completedAuditDataKey.label": "completedAudit",
  "operationalAuditsDataKey.label": "Planned Operational Audits",
  "repairCompleteAuditDataKey.label": "Repair Completed Audit",
  "repairAuditDataKey.label": "Planned Repair Audits",
  "totalAuditDataKey.label": "Total Audit",
  "totalCompletedAuditDataKey.label": "Total Completed Audit",
  "filter.label.auditType": "Audit Type",
  "filter.label.country": "Country",
  "filter.label.year": "Year",
  "filter.label.subCategory": "Sub Category",
  "filter.label.dnsd": "DNSD",
  "errorPage.routes.value": "Page not found",
  "errorPage.header.value": "Oops! An Error Occurred",
  "graph.tooltip.totalVsCompleteAudit.p1":
    "This graph contains the data corresponding to all audits and shows the Total audits created under the selected filters vs the completed ones",
  "graph.tooltip.totalVsCompleteAudit.p2":
    "The above-mentioned data is also shown separately for the operation and repair audit",
  "graph.tooltip.planVsCompleteAudit.monthVise.p1":
    "This graph contains the data corresponding to all audits and shows the Total operation/repair audits planned under the selected filters vs the operation/repair completed ones, month wise of the selected financial year",
  "graph.tooltip.grading.p1":
    "This graph contains data from the single latest version of the questionnaire of a country only",
  "graph.tooltip.grading.p2":
    "This graph shows the number of DNSD’s grade-wise for completed audits only (Grades A (91-100% of ok result questions after audit completed), B (71-90%), C(51-70%), D (<51%)",
  "graph.tooltip.radar.p1":
    "This graph contains data from the single latest version of the questionnaire of a country only",
  "graph.tooltip.radar.p2":
    "This graph shows the number/percentage of questions under level 1 marked with evaluation status = OK of completed audits only",
  "graph.tooltip.level2.p1":
    "This graph contains data from the single latest version of the questionnaire of a country only",
  "graph.tooltip.level2.p2":
    "This graph shows the number/percentage of questions under level 2 marked with evaluation status = OK of completed audits only",
  "graph.tooltip.level3.p1":
    "This graph contains data from the single latest version of the questionnaire of a country only",
  "graph.tooltip.level3.p2":
    "This graph shows the number/percentage of questions under level 3 marked with evaluation status = OK of completed audits only",
  "graph.tooltip.level4.p1":
    "This graph contains data from the single latest version of the questionnaire of a country only",
  "graph.tooltip.level4.p2":
    "This graph shows the number/percentage of questions under level 4 marked with evaluation status = OK of completed audits only",
  "navbar.noNotification": "No notification",
  "graph.tooltip.level5.p1":
    "This graph contains data from the single latest version of the questionnaire of a country only",
  "graph.tooltip.level5.p2":
    "This graph shows the number/percentage of questions under level 5 marked with evaluation status = OK of completed audits only",
  "remoteAudit.callEnded": "You have left the remote call",
  "dnsd.popup.noaccess_msg":
    "You are presently signed in under a different user account. Kindly sign out from this account.",
  "asktoJoin.label": "Ask to Join",
  "pleaseWait.label": "Please wait...",
  "offline.popup": "Offline Notification",
  "offline.popup.desc":
    "You are currently offline. Please check your internet connection.",
  accessDenied: "Access Denied",
  "accessDenied.permissionDenied":
    "Sorry, you do not have permission to access this page.",
  "error.forbidden": "error code:403 forbidden",
  "resetPassword.weakPassword": "Password does not meet the minimum requirements.",
};
